const DEFAULT_DEPLOYMENT_POLL_INTERVAL_MS = 5 * 60 * 1000;

export function hasDeploymentChanged(clientBuildId: string | undefined, serverBuildId: string | undefined): boolean {
  if (!clientBuildId || !serverBuildId) {
    return false;
  }

  return clientBuildId !== serverBuildId;
}

export interface StartDeploymentPollingParams {
  checkForNewDeployment: () => Promise<boolean>;
  onNewDeployment: () => void;
  intervalMs?: number;
}

export function startDeploymentPolling({
  checkForNewDeployment,
  onNewDeployment,
  intervalMs = DEFAULT_DEPLOYMENT_POLL_INTERVAL_MS,
}: StartDeploymentPollingParams): () => void {
  const pollForNewDeployment = async (): Promise<void> => {
    if (await checkForNewDeployment()) {
      onNewDeployment();
    }
  };

  void pollForNewDeployment();
  const intervalId = setInterval(() => {
    void pollForNewDeployment();
  }, intervalMs);

  return () => clearInterval(intervalId);
}
